import React from 'react';
import { BASE_SERVICE_PATH, FREE_BASE_SERVICE_PATH, DETECTION_PATH, FREE_DETECTION_PATH, AUTHENTICATION_PATH, FREE_AUTHENTICATION_PATH, ADVANCED_SERVICE_PATH, FREE_ADVANCED_SERVICE_PATH, ANNOTATION_SERVICE_PATH, FREE_ANNOTATION_SERVICE_PATH } from '../../util/consts';
import { Redirect } from 'react-router-dom';

const baseServiceConfig = {
    settings: {
        customScrollbars: false,
        layout: {
            style: 'layout1',
            config: {
                needUserInfo: true,
                redirectOn401: true,
                hasPreview: true,
                navbar: {
                    folded: true
                },
                footer: {
                    display: true
                }
            }
        }
    },
    routes: [
        {
            path: [
                FREE_BASE_SERVICE_PATH + '/inpainting-1',
                BASE_SERVICE_PATH + '/inpainting-1'
            ],
            component: () => <Redirect to={BASE_SERVICE_PATH + '/inpainting/'} />
        },
        {
            path: [
                FREE_BASE_SERVICE_PATH + '/arcLine-detector',
                BASE_SERVICE_PATH + '/arcLine-detector'
            ],
            component: () => <Redirect to={BASE_SERVICE_PATH + '/arc-line-detector/'} />
        },
        {
            path: [
                FREE_BASE_SERVICE_PATH + '/denoising',
                BASE_SERVICE_PATH + '/denoising',
            ],
            component: () => <Redirect to={BASE_SERVICE_PATH + '/denoising-1/'} />
        },
        {
            path: [
                FREE_DETECTION_PATH + '/pose-estimation',
                DETECTION_PATH + '/pose-estimation'
            ],
            component: () => <Redirect to={DETECTION_PATH + '/pose-estimation-1/'} />
        },
        {
            path: [
                FREE_DETECTION_PATH + '/face-recognition',
                DETECTION_PATH + '/face-recognition'
            ],
            component: () => <Redirect to={AUTHENTICATION_PATH + '/face-recognition/'} />
        },
        {
            path: [
                FREE_ANNOTATION_SERVICE_PATH + '/boundary-annotation',
                ANNOTATION_SERVICE_PATH + '/boundary-annotation',
            ],
            component: () => <Redirect to={ANNOTATION_SERVICE_PATH + '/boundary-annotation-1/'} />
        },
        {
            path: [
                FREE_BASE_SERVICE_PATH + '/:serviceName',
            ],
            component: ({ match }) => <Redirect to={`${BASE_SERVICE_PATH}/${match.params.serviceName}/`} />
        },
        {
            path: [
                FREE_DETECTION_PATH + '/:serviceName',
            ],
            component: ({ match }) => <Redirect to={`${DETECTION_PATH}/${match.params.serviceName}/`} />
        },
        {
            path: [
                FREE_AUTHENTICATION_PATH + '/:serviceName',
            ],
            component: ({ match }) => <Redirect to={`${AUTHENTICATION_PATH}/${match.params.serviceName}/`} />
        },
        {
            path: [
                FREE_ADVANCED_SERVICE_PATH + '/:serviceName',
            ],
            component: ({ match }) => <Redirect to={`${ADVANCED_SERVICE_PATH}/${match.params.serviceName}/`} />
        },
        {
            path: [
                FREE_ANNOTATION_SERVICE_PATH + '/:serviceName/:id?',
            ],
            component: ({ match }) => <Redirect to={`${ANNOTATION_SERVICE_PATH}/${match.params.serviceName}/${match.params.id ? match.params.id : ''}/`} />
        },
        {
            path: [
                BASE_SERVICE_PATH + '/:serviceName',
                DETECTION_PATH + '/:serviceName',
                AUTHENTICATION_PATH + '/:serviceName',
                ADVANCED_SERVICE_PATH + '/:serviceName',
                ANNOTATION_SERVICE_PATH + '/:serviceName/:id?',
            ],
            component: React.lazy(() => import('./base-service-layout'))
        },
    ]
};

export { baseServiceConfig };
